import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-professor-list',
    templateUrl: './professor-list.component.html',
    imports: [CommonModule,],
    styleUrls: ['./professor-list.component.css']
})
export class ProfessorListComponent {
  @Input('vue') vue:any="list"
  @Input('data') data:any=[]

  getTotalHourly(courses:any){
    let hourly:any=0

    courses.forEach((element:any) => {
      hourly+=element.pivot.hourly_weight
    });
    return hourly
  }
}
